import styled, { keyframes, css } from 'styled-components/macro';
import iconRotation from 'images/rotation_arrow_turquoise.svg';
import iconEyeTurquoise from 'images/eye_turquoise.svg';
import iconDeleteTurquoise from 'images/icon_delete_turquoise.svg';
import iconPlusTurquoise from 'images/icon_plus_turquoise.svg';
import { actionBarHeight, blueBarHeight, headerHeight } from 'utils/styleConstants';

export const PdfUploaderWrapper = styled.div`
  font-size: ${({ theme }) => theme.fontSizePalette.xSmall};
  font-family: ${({ theme }) => theme.fontFamily};
  font-weight: ${({ theme }) => theme.fontWeightPalette.light};
  color: ${({ theme }) => theme.colorPalette.grey.grey9};
`;

const pageHoverEffect = (from: string, to: string) =>
  keyframes`
  from { background-color: ${from}255}
  to  { background-color: ${to}50}
`;

export const Zoom = styled.div`
  grid-column: 1;
  grid-row: 1;
  &:hover {
    background-image: url('${iconEyeTurquoise}');
    background-repeat: no-repeat;
    background-position: 20% 15%;
    background-size: 15px 15px;
  }
`;

export const RotateRight = styled.div`
  grid-column: 1;
  grid-row: 2;
  &:hover {
    background-image: url('${iconRotation}');
    background-repeat: no-repeat;
    background-position: 20% 85%;
    background-size: 15px 15px;
  }
`;

export const RotateLeft = styled.div`
  grid-column: 2;
  grid-row: 2;
  transform: scaleX(-1);
  &:hover {
    background-image: url('${iconRotation}');
    background-repeat: no-repeat;
    background-position: 20% 85%;
    background-size: 15px 15px;
  }
`;

export const Delete = styled.div<{ status: boolean }>`
  padding: 10px;
  grid-column: 2;
  grid-row: 1;
  &:hover {
    background-image: ${({ status }) => (status ? `url('${iconPlusTurquoise}')` : `url('${iconDeleteTurquoise}')`)};
    background-repeat: no-repeat;
    background-position: 80% 15%;
    background-size: 15px 15px;
  }
`;

export const PageAction = styled.div`
  top: 0;
  position: absolute;
  display: grid;
  left: 0;
  width: 100%;
  height: 100%;
  grid-template-columns: 50% 50%;
  grid-template-rows: 50% 50%;
  cursor: pointer;
  &:hover {
    animation-name: ${({ theme }) =>
      pageHoverEffect(theme.colorPalette.turquoise.light, theme.colorPalette.turquoise.light)};
    animation-duration: 0.25s;
    animation-fill-mode: forwards;
  }
`;

const dottedSplitEffect = css`
  background: linear-gradient(
    0deg,
    ${({ theme }) => theme.colorPalette.turquoise.dark} 12.5%,
    transparent 12.5%,
    transparent 37.5%,
    ${({ theme }) => theme.colorPalette.turquoise.dark} 37.5%,
    ${({ theme }) => theme.colorPalette.turquoise.dark} 62.5%,
    transparent 62.5%,
    transparent 87.5%,
    ${({ theme }) => theme.colorPalette.turquoise.dark} 87.5%
  );
  background-position: center;
  background-repeat-y: repeat;
  background-repeat-x: no-repeat;
  background-size: 3px 60px;
`;

export const Divider = styled.div<{ active?: Boolean }>`
  width: 25px;
  &:hover {
    ${dottedSplitEffect};
  }
  ${({ active }) => active && dottedSplitEffect};
`;

export const InfoDocument = styled.div`
  padding: 10px 0;
  display: flex;
  justify-content: space-between;
  max-width: calc(100% - 40px);
`;

export const PdfHeader = styled.div`
  display: flex;
  padding: 6px 12px;
  border-bottom: 1px solid ${({ theme }) => theme.colorPalette.grey.grey5};
`;

export const PdfWrapper = styled.div``;

export const PdfContainer = styled.div`
  padding: 12px 25px;
  width: 100%;
`;

export const SplitterWrapper = styled.div`
  padding-bottom: 20px;
  max-height: calc(100vh - ${blueBarHeight + actionBarHeight + headerHeight}px);
  overflow: auto;
`;

export const MassiveWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 25px;
`;

export const MassivePdf = styled.div`
  width: 300px;
  padding: 10px 20px;
  margin-bottom: 10px;
  border: 1px solid ${({ theme }) => theme.colorPalette.grey.grey5};
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
`;

export const NameMassivePdf = styled.div`
  max-width: 190px;
`;

export const DeleteMassivePdf = styled.div`
  cursor: pointer;
  text-decoration: underline;
  color: ${({ theme }) => theme.colorPalette.turquoise.normal};
`;

export const PageNumber = styled.div`
  text-align: center;
  font-size: ${({ theme }) => theme.fontSizePalette.small};
  position: absolute;
  bottom: -35px;
  left: 0;
  right: 0;
`;

export const SpinnerContainer = styled.div`
  height: calc(100vh - ${blueBarHeight + headerHeight}px);
`;
